import { render, staticRenderFns } from "./inRecordAdmin.vue?vue&type=template&id=6f3bc9ad&scoped=true"
import script from "./inRecordAdmin.vue?vue&type=script&lang=js"
export * from "./inRecordAdmin.vue?vue&type=script&lang=js"
import style0 from "./inRecordAdmin.vue?vue&type=style&index=0&id=6f3bc9ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3bc9ad",
  null
  
)

export default component.exports